import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Utility function for resolving styling conflict of tailwind
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
